import React from 'react';
import './style.scss';

export const TypeProgressBar = ({ title, percent }) => (
  <div className="type_progress_bar">
    <div className="type_progress_bar_wrapper">
      <div className="type_progress_bar_percent" style={{ height: `${percent}%` }}>
        {percent !== 0 && <span>{percent}%</span>}
      </div>
    </div>
    <p>{title}</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/TypeProgressBar/index.js